import { render, staticRenderFns } from "./ReviewsUpcoming.vue?vue&type=template&id=1ecd6190&scoped=true"
import script from "./ReviewsUpcoming.vue?vue&type=script&lang=js"
export * from "./ReviewsUpcoming.vue?vue&type=script&lang=js"
import style0 from "./ReviewsUpcoming.vue?vue&type=style&index=0&id=1ecd6190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecd6190",
  null
  
)

export default component.exports